/* eslint-disable no-unused-vars */
import { FormFieldType } from '@/constants/form/FormFieldType'

/**
 * Creates an instance of FormField.
 * @typedef {Object} FormFieldObjType
 * @property {string} id - The unique identifier for the field.
 * @property {FormFieldType} fieldType - The type of the field (e.g., "Text", "Signature", etc.).
 * @property {string} key - The key of the field.
 * @property {string} label - The label for the field.
 * @property {?string} description - A description for the field (nullable).
 */

/**
 * Represents a form field.
 * @class
 */
export class FormField {
  /**
   * Create a new FormField.
   * @param {FormFieldObjType} params
   */
  constructor(params) {
    this.id = params.id
    this.fieldType = params.fieldType
    this.key = params.key
    this.label = params.label
    this.description = params.description
  }
}
